import { Action, createReducer, on } from '@ngrx/store';

import * as OrderActions from './order.actions';
import { initialState, OrderState } from './order.state';

const orderReducer = createReducer(
  initialState,
  on(OrderActions.placeOrderSuccess, (state, { response }) => {
    return { ...state, selectedOrder: response };
  }),
  on(OrderActions.processSuccess, (state, { response }) => {
    return { ...state, isPaymentCompleted: true, selectedOrder: response };
  }),
  on(OrderActions.resetPaymentStatus, (state) => {
    return { ...state, isPaymentCompleted: null };
  }),
  on(OrderActions.rehydrateOrderState, (state, { orderState }) => {
    return { ...state, ...orderState };
  })
);

export function reducer(state: OrderState | undefined, action: Action) {
  return orderReducer(state, action);
}
